<template>
  <el-container
    v-loading="fullscreenLoading"
    element-loading-text="正在加载相关数据..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    style="margin-top: 100px; height: 85vh"
  >
    <el-main>
      <el-input
        prefix-icon="el-icon-search"
        v-model="search"
        placeholder="通过项目名称查找对应项目"
        :clearable="true"
        :autofocus="true"
      />
      <el-table
        ref="tbl"
        :data="
          options.filter(
            (data) =>
              !search || data.name.toLowerCase().includes(search.toLowerCase())
          )
        "
        height="90%"
        style="width: 100%"
        row-key="id"
        :row-class-name="tableRowClassName"
        border
        stripe
        highlight-current-row
        @current-change="handleCurrentChange"
        @row-click="selectOK"
        lazy
        :load="loadChild"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column fixed type="index"></el-table-column>
        <el-table-column
          fixed
          sortable
          prop="name"
          label="项目名称"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="projecttype" label="项目类型" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.projecttype }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="工程地址" width="380">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.address }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="area" label="占地面积" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.area }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totals" label="投资金额" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.totals }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <!-- <el-footer style="text-align: right; font-size: 12px">      
    </el-footer> -->
  </el-container>
</template>
<script>
import { getAutoCDMProjects } from "@/ref/autocdm/utils.js";
import { mapState } from "vuex";
export default {
  name: "projecttable",
  components: {},
  data() {
    return {
      search: "",
      currentRow: null,
    };
  },
  computed: {
    ...mapState({
      fullscreenLoading: (state) => state.tbim.loadingStart,
    }),
    options: function () {
      let _this = this;
      let pis = this.$store.state.tbim.projectInfos;
      if (!pis || pis.length == 0) {
        let currentUser = sessionStorage.getItem("user");
        currentUser = currentUser != "chenhs" ? currentUser : "admin";
        currentUser =
          currentUser != "chenhs@mail.toone.com.cn" ? currentUser : "admin";
        let getAutoCDMProjectsPromise = getAutoCDMProjects(currentUser);
        //初始化当前用户的所有项目
        getAutoCDMProjectsPromise.then(function (as) {
          let pinfos = [];
          as.forEach(function (a) {
            let aa = {};
            pinfos.push(aa);
            aa.id = a.id;
            aa.label = a.name;
            aa.name = a.name;
            aa.address = a.site;
            aa.totals = a.investment;
            aa.jsdw = a.jsdw;
            aa.sgdw = a.sgdw;
            aa.jldw = a.jldw;
            aa.sjdw = a.sjdw;
            aa.projecttype = a.projectType;
            aa.area = a.area;
            aa.hasChildren = aa.projecttype == "road";
          });
          //
          _this.$store.commit("setProjectInfos", pinfos);
        });
      }
      return this.$store.state.tbim.projectInfos;
    },
  },
  props: {},
  methods: {
    selectOK: function () {
      this.$store.commit("setModelGroup", null);
      this.$store.commit("setGanttTasks", {
        data: [],
        links: [],
      });
      this.$store.commit("setSelectedProjectInfo", this.currentRow);
      this.$emit("selectOK");
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    loadChild(tree, treeNode, resolve) {
      let projectid = tree.id;
      if (!projectid) return;
      let promise = this.$api.autoCDM.getAutoCDMSubProjects(projectid);
      console.log(projectid);
      promise
        .then(function (val) {
          if (val) {
            let datas = val.data;
            if (datas instanceof Array && datas.length > 0) {
              let ret = [];
              datas.forEach(function (d) {
                let dd = {
                  id: d.eid,
                  name: d.ename,
                  label: d.ename,
                  projecttype: d.etype,
                };
                ret.push(dd);
              });
              resolve(ret);
            }
          }
          //-----------------
          resolve([]);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    tableRowClassName(row, rowIndex) {
      console.log(row);
      console.log(rowIndex);
      return "projectselectionrowclass";
    },
  },
  mounted: function () {
    this.$store.commit("setCollapse", true);
    if (this.currentRow) this.$refs.tbl.setCurrentRow(this.currentRow);
  },

  beforeCreate: function () {},
  destroyed: function () {
    this.$store.commit("setCollapse", false);
  },
};
</script>
<style>
.projectselectionrowclass {
  cursor: pointer;
}
</style>
<style scoped>
.el-footer {
  color: #333;
  line-height: 60px;
}

.el-input {
  position: relative;
  width: 300px;
  float: left;
  margin-left: 10px;
  margin-bottom: 10px;
}
.el-button {
  position: absolute;
  margin-top: 0px;
  left: 45%;
  width: 150px;
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/views/Tbim/ProjectSelection.vue